import { Controller } from "react-hook-form";
import { Box, FormControl, FormHelperText } from "@mui/material";
import { FormLabel, Password } from "../../../../components";
import { SubmitButton } from "../../../SignUp/partials/SubmitButton";
import { PasswordRequirements } from "../../../SignUp/partials/PasswordRequirements";
import { useSetNewPassword } from "../../hooks/useSetNewPassword";

type TSetNewPasswordFormProps = {
  onSuccess: () => void;
  token: string; // Comes from the URL search params
};

export const SetNewPasswordForm = ({
  onSuccess,
  token,
}: TSetNewPasswordFormProps) => {
  const { errors, control, isSubmitting, onSubmit } = useSetNewPassword({
    onSuccess,
    token,
  });

  return (
    <Box component="form" width="100%" onSubmit={onSubmit} noValidate>
      <Controller
        control={control}
        name="password"
        render={({ field, fieldState }) => (
          <FormControl
            error={fieldState.invalid}
            sx={{ width: "100%", mt: 2.5 }}
          >
            <FormLabel
              renderTooltipContent={() => <PasswordRequirements />}
              htmlFor="password"
            >
              New Password
            </FormLabel>
            <Password
              {...field}
              fullWidth
              disabled={isSubmitting}
              error={fieldState.invalid}
              helperText={fieldState.error?.message}
              id="password"
              placeholder="Enter new password"
            />
          </FormControl>
        )}
      />
      <Controller
        control={control}
        name="confirmPassword"
        render={({ field, fieldState }) => (
          <FormControl
            error={fieldState.invalid}
            sx={{ width: "100%", mt: 2.5, mb: 3.5 }}
          >
            <FormLabel htmlFor="confirm-password">Confirm Password</FormLabel>
            <Password
              {...field}
              fullWidth
              disabled={isSubmitting}
              error={fieldState.invalid}
              helperText={fieldState.error?.message}
              id="confirm-password"
              placeholder="Confirm password"
            />
          </FormControl>
        )}
      />
      <SubmitButton
        type="submit"
        disabled={isSubmitting}
        loading={isSubmitting}
      >
        Set New Password
      </SubmitButton>

      {Object.entries(errors).map(([key, error]) => {
        if (!error) return null;
        return (
          <FormHelperText error key={key}>
            {error}
          </FormHelperText>
        );
      })}
    </Box>
  );
};
